var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDuplo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.543,
    height: 16.217,
    viewBox: "0 0 20.543 16.217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1713",
    "data-name": "Grupo 1713",
    transform: "translate(-855.234 -117.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chevron-left",
    "data-name": "Icon awesome-chevron-left",
    d: "M.256,7.327,7.328.256a.873.873,0,0,1,1.235,0l.825.825a.873.873,0,0,1,0,1.234l-5.6,5.631,5.6,5.631a.873.873,0,0,1,0,1.234l-.825.825a.873.873,0,0,1-1.235,0L.256,8.562A.873.873,0,0,1,.256,7.327Z",
    transform: "matrix(-0.999, -0.035, 0.035, -0.999, 864.872, 134.049)",
    fill: "#00838d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chevron-left-2",
    "data-name": "Icon awesome-chevron-left",
    d: "M.256,7.327,7.328.256a.873.873,0,0,1,1.235,0l.825.825a.873.873,0,0,1,0,1.234l-5.6,5.631,5.6,5.631a.873.873,0,0,1,0,1.234l-.825.825a.873.873,0,0,1-1.235,0L.256,8.562A.873.873,0,0,1,.256,7.327Z",
    transform: "matrix(-0.999, -0.035, 0.035, -0.999, 875.222, 134.049)",
    fill: "#00838d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDuplo);
export default __webpack_public_path__ + "static/media/chevronDuplo.ffa2210d21ad5aaf295fd506072de48d.svg";
export { ForwardRef as ReactComponent };